import { QueovalBase } from './queoval.base';
import { Translation, QueovalRole, ConfigModelDB, Client } from 'projects/lib-components/src/public_api';
import { Catalog, Category, Product, Cycle, CycleYear, CycleMonth, Stage, StageYear, StageMonth, Responsable, Address, ProductLink, StagePrice } from './classes.catalogsformations';
import { DBField } from './db.field';
import { WSUserRole } from './generic.data';


export class InitModel extends QueovalBase {
  public Roles: QueovalRole;
  public TranslationLib: Translation;
}

/* ------------------------------------------------------ */

export class HomeModel extends QueovalBase {
  public UserRole: WSUserRole;
  public ListApprenantsOrderedByClients: Array<Client>;
  public ListRHsOrderebByClients: Array<Client>;
  public CountStages: number;
  public CountCycles: number;
  public Config: ConfigModelDB;
  public Facebook: string;
  public Twitter: string;
  public Linkedin: string;
  public Viadeo: string;
}

/* ------------------------------------------------------ */

export class CatalogsModel extends QueovalBase {
  CatalogueList: Catalog[];
  CategorieList: Category[];
  CatalogSelected: Catalog;
}

/* ------------------------------------------------------ */

export class CategorieModel extends QueovalBase {
  public Categorie: Category;
  public CategorieList: Category[];
  public ProductList: Product[];
}

/* ------------------------------------------------------ */

export class ProductsModel extends QueovalBase {
  public ProductList: Product[];
  public SelectedProduct: Product;
  public ProductLink: ProductLink;
  public Config: ConfigModelDB;
}

/* ------------------------------------------------------ */

export class CycleModel extends QueovalBase {
  CycleList: Cycle[];
  CycleYearsList: CycleYear[];
  CycleMonthsList: CycleMonth[];
  StageList: Stage[];
}

/* ------------------------------------------------------ */

export class StagesModel extends QueovalBase {
  StageList: Stage[];
  StageYearsList: StageYear[];
  StageMonthsList: StageMonth[];
  StageProduct: Product[];
  CatalogueList: Catalog[];
  AddressList: Address[];


  public SelectedStageResponsablesList: Responsable[];
  public SelectedStageaddressesList: Address[];
  public SelectedStageProduct: Product;

  public TotStagePreinscription: number;
  public TotStageInscription: number;
  public FullStage: string;

  public FormulaireStage: Stage;

  public StageModelOptimized: StageModelOPT;
}

export class StageModelOPT {
  public Stages: Array<StageDataOPT>;

  public Catalogs: Array<CatalogueOPT>
  public FilterYears: Array<StageYear>;
  //public FilterMonths: Array<StageMonth>;

  public Addresses: Array<AddressOPT>;
  public FilterAddresses: Array<AddressOPT>;
}
export class StageDataOPT {
  public Ident: string;
  public NumstPRO: string;
  public ProduPRO: string;
  public Info_PRO: string;
        //public DateTime datedPRO
  public DatedPro: string;
        //public DateTime datefPRO
  public DatefPro: string;
  public PrestPRO: string;
  public DureePRO: string;
  public PjextPRO: string;
  public PartiPRO: string;
  public CapstPRO: string;
  public NbstaPRO: string;
  public ProductPreRePRO: string;
  public ProductProgrPRO: string;
  public ProductPedagPRO: string;
  public PricesList: Array<StagePrice>;

  public year: number;
  public month: number;
  public DetailsFileName: string;

  public ResponsablesList: Array<Responsable>;
  public AddressesList: Array<Address>;
  public OptionalFields: Array<DBField>;
}

export class AddressOPT {
  public Ident: string;
  public Adre1ADR: string;
  public Adre2ADR: string;
  public Adre3ADR: string;
  public VilleADR: string;
  public DenomADR: string;

  public FormatADR: string;

  public IdStageRef: string;
}
export class CatalogueOPT {
  public Ident: string;
  public Name_CTL: string;

  public ListCategory: Array<CategorieOPT>;
}
export class CategorieOPT {
  public Ident: string;
  public User_CAT: string;
  public Nom__CAT: string;
  public Desc_CAT: string;

  public ListProd: Array<ProdDataFLT>;
  public ListStages: Array<StageDataFLT>;
}
export class StageDataFLT {
  public IdStage: string;
  //public IdProduct: string;
  //public DescProduct: string;
  //public DateTime datedPRO
  public year: number;
  public month: number;
  public ParentProduct: Product;
}
export class ProdDataFLT {
  //public IdStage: string;
  public IdProduct: string;
  public CodeProduct: string;
  public DescProduct: string;
  public ListStages: Array<string>;

  //public DateTime datedPRO
  //public year: number;
  //public month: number;
  //public ParentProduct: Product;
}

